let contact_sidebar = ( function( $ ) {

	let $sidebar,
		anim_speed = 400;

	let _init = function() {
		$sidebar = $( '.contact-sidebar' );

		if ( $sidebar.length > 0 ) {
			_setup_sidebar();
		}
	};

	let _setup_sidebar = function() {
		$sidebar.find( 'a.toggle-link' ).on( 'click', function( e ) {
			e.preventDefault();
			_toggle_menu();
		} );
	};

	let _toggle_menu = function() {
		if ( $sidebar.hasClass( 'animating' ) ) {
			return;
		}

		if ( ! $sidebar.hasClass( 'open' ) ) {
			_open_menu();
		} else {
			_close_menu();
		}
	};

	let _open_menu = function() {
		$sidebar.addClass( 'animating' );

		$sidebar.find( '.toggle-panel' ).slideDown( anim_speed );

		setTimeout( function() {
			$sidebar.addClass( 'open' );
			$sidebar.removeClass( 'closed' );
			$sidebar.removeClass( 'animating' );
			_change_button_text()
		}, anim_speed );
	};

	let _close_menu = function() {
		$sidebar.addClass( 'animating' );

		$sidebar.find( '.toggle-panel' ).slideUp( anim_speed );

		setTimeout( function() {
			$sidebar.addClass( 'closed' );
			$sidebar.removeClass( 'open' );
			$sidebar.removeClass( 'animating' );
			_change_button_text();
		}, anim_speed );
	};

	let _change_button_text = function() {
		let $button      = $sidebar.find( 'a.toggle-link' ),
			current_text = $button.text(),
			new_text     = $button.data( 'alt-text' );

		$button.text( new_text );
		$button.data( 'alt-text', current_text );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = contact_sidebar;